import { initClient } from "rwsdk/client";
import { initPostHog } from "@/lib/posthog";

// CSS is loaded via link tag in document.tsx
import "./app/styles.css";

initClient();
initPostHog();
